import type { TournamentListItemResponse } from "../../../@apis/dto/response/torunament.response";
import { formatDate, formatDateRange } from "../../../lib/utils/dateUtils";
import { resolveTournamentListStatus } from "../../../lib/utils/tournamentUtils";
import { cn } from "../../../lib/utils/cn";

interface Props {
  item: TournamentListItemResponse;
  onClick?: () => void;
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex gap-[8px] items-start">
      <p className="shrink-0 text-[#8e8e93]">{label}</p>
      <div className="flex-1 min-w-0 text-black break-keep whitespace-pre-line [overflow-wrap:anywhere]">
        {value}
      </div>
    </div>
  );
}

export default function CompetitionListCard({ item, onClick }: Props) {
  const status = resolveTournamentListStatus(item);

  const applyStartTs = item.isReapply
    ? item.reapplyStartDtTimestamp
    : item.applyStartDtTimestamp;

  const applyEndTs = item.isReapply
    ? item.reapplyEndDtTimestamp
    : item.applyEndDtTimestamp;

  const periodLabel = formatDateRange(
    item.startDt,
    item.endDt,
    "YYYY.MM.DD (ddd)",
  );

  return (
    <div
      onClick={onClick}
      className="bg-white border border-[#d1d1d6] rounded-[10px] px-[16px] py-[12px] flex flex-col gap-[12px] cursor-pointer"
    >
      <div className="flex items-center justify-between">
        <div
          className={cn(
            "py-[2.5px] px-[10px] rounded-[5px] flex items-center justify-center gap-[5px] text-sm font-medium whitespace-nowrap",
            status.badgeClassName,
          )}
        >
          {status.hasCheck && (
            // 아이콘 색은 배지 텍스트 색(currentColor)을 따라가 상태별로 달라진다
            <svg
              width="1rem"
              height="1rem"
              viewBox="0 0 16 16"
              fill="none"
              className="shrink-0"
            >
              <path
                d="M13.3307 4L5.9974 11.3333L2.66406 8"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          {status.label}
        </div>
        <img className="w-1.5 h-3.5" src="/icons/ic-go.webp" />
      </div>

      <div className="h-px w-full bg-[#e5e5ea]" />

      <p className="text-base font-semibold text-black break-keep">
        {item.name}
      </p>

      <div className="flex flex-col gap-[8px] text-sm font-medium">
        <InfoRow label="대회기간" value={periodLabel} />
        <InfoRow
          label="접수기간"
          value={`${formatDate(
            new Date(applyStartTs),
            "YYYY.MM.DD (ddd)",
          )} ~ ${formatDate(new Date(applyEndTs), "YYYY.MM.DD (ddd)")}`}
        />
        <InfoRow label="대회장소" value={item.golfParkName} />
      </div>
    </div>
  );
}
